var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webkit-webcamBanner-container" }, [
    _c("div", { staticClass: "webkit-webcamBanner-grid" }, [
      _c("h2", {
        staticClass: "webkit-webcamBanner-title",
        domProps: { innerHTML: _vm._s(_vm.heading) }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "webkit-webcamBanner-grid" },
      [
        _c("CoolLightBox", {
          attrs: { items: _vm.items, index: _vm.index },
          on: {
            close: function($event) {
              _vm.index = null
            }
          }
        }),
        _vm._v(" "),
        _vm._l(_vm.blocks, function(webcam, imageIndex) {
          return _c(
            "div",
            {
              key: imageIndex,
              on: {
                click: function($event) {
                  _vm.index = imageIndex
                }
              }
            },
            [
              _c("div", {
                staticClass:
                  "webkit-webcamBanner-image h-60 cursor-pointer bg-center bg-cover",
                style: { backgroundImage: "url(" + webcam.img + ")" }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "webkit-webcam-heading",
                domProps: { innerHTML: _vm._s(webcam.heading) }
              })
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }